import "common/assets/css/spinner.css";

const Spinner = ({
  size = 30,
  paddingRight = 0,
  border = "5px solid #f3f3f3",
  borderTop = "5px solid var(--chakra-colors-cta-100)",
}) => (
  <div
    className="loader"
    style={{
      width: `${size}px`,
      height: `${size}px`,
      border: `${border}`,
      marginRight: `${paddingRight}px`,
      borderTop: `${borderTop}`,
    }} // Set dynamic width and height
  ></div>
);

export default Spinner;
